import React from "react";

const Note = () => {
    return (
        <div className="note-wrapper">
            NOOOOOOOOTE!!!!

        </div>
    )
}

export default Note;